import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';
import { useAuth } from '../../context/auth';
import type { UserStatus } from '../../types/profile';

interface AccountInactiveProps {
  status?: UserStatus;
}

export const AccountInactive: React.FC<AccountInactiveProps> = ({ status = 'inactive' }) => {
  const { t } = useTranslation('common');
  const { signOut } = useAuth();

  const statusKey: 'suspended' | 'banned' | 'inactive' =
    status === 'suspended' || status === 'banned' ? status : 'inactive';

  return (
    <div className="min-h-screen bg-primary-inverse flex flex-col items-center justify-center px-4">
      <div className="text-center space-y-8 max-w-2xl">
        <div className="text-7xl" aria-hidden>
          🔒
        </div>

        <div className="space-y-4">
          <h1 className="text-4xl font-bold text-secondary">
            {t(`accountInactive.${statusKey}.title`)}
          </h1>
          <p className="text-xl text-[#3B5266]">{t(`accountInactive.${statusKey}.subtitle`)}</p>
        </div>

        <p className="text-base text-[#3B5266]">
          {t('accountInactive.contactSupport')}{' '}
          <a
            href="mailto:support@pigeons.app"
            className="text-secondary font-bold underline hover:opacity-80"
          >
            support@pigeons.app
          </a>
        </p>

        <div className="flex justify-center mt-8">
          <Button variant="primary" onClick={() => signOut()}>
            {t('accountCard.signOut')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AccountInactive;
